/**
 * 描述：评价系统 ----个人、企业信用 接口管理
 * Created by 钱磊
 * 时间：2022-5-20 16:35:03
 */
 import request from '../../request.js'
/**
* 描述：获取个人、企业信用分页列表
* 接口管理员：赵建强
* 参数： 
{
    assType:'',          // 信用对象类型 0：个人 1：企业
    assName:'',       // 信用对象名称
    assNo:'',         // 证件号
    size:10,          // 当前每页条数
    current:1,        // 当前页码
}
*/
export const getSummaryPageList = function (data) {
  return request({
      url: '/ngsAssess/selSummaryPageList',
      method: 'post',
      requestConfig: {
          hideLoading: true
      },
      data
  })
}


/**
* 描述：通过被评方获取评价记录分页列表
* 接口管理员：赵建强
* 参数： 
{
    beAssType:'',      // 被评价方类型 0：个人 1：企业
    beAssId:'',       // 被评价方id
    size:10,          // 当前每页条数
    current:1,        // 当前页码
}
*/
export const selRecordPageList = function (data) {
  return request({
      url: '/ngsAssess/selRecordPageList',
      method: 'post',
      requestConfig: {
          hideLoading: true
      },
      data
  })
}
